import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import ModalCadastro from '../_base/modal-cadastro';

import PedidoService from '../../services/pedido-service';
import ResumoPedidoAvaliacao from '../resumo-pedido-avaliacao';
import { processError } from '../../helpers/axios.config';

// import "./styles.scss";

export default function ModalResumoPedidoAvaliacao(props) {
  const { model, showModal, setShowModal, onClose } = props;
  const [errors, setErrors] = useState({});

  const queryClient = useQueryClient();

  async function aprovar() {
    window.showLoader();
    //setErrors({});
    let response = await PedidoService.aprovarAsync(model.pedidoRepresentadaId);
    if (response?.data?.errors) {
      //setErrors(response?.data?.errors);
    } else {
      await queryClient.invalidateQueries(['pedidos']);
      setShowModal(false);
    }
    window.hideLoader();
  }

  async function cancelar() {
  window.showLoader();

  try {
    console.log('🟡 chamando cancelarAsync...');

    let response = await PedidoService.cancelarAsync(
      model.pedidoRepresentadaId
    ).catch((error) => { // ✅ catch direto na promise
      console.log('🔴 catch na promise! status:', error.response?.status);
      if (error.response?.status == 403) {
        setErrors({
          permissao: [
            error.response?.data?.message ||
            'Você não possui permissão.'
          ]
        });
      }
      return null; // sinaliza que houve erro
    });

    if (response === null) return; // saiu por erro

    console.log('🟢 response:', response);

    if (response?.data?.errors) {
      setErrors(response?.data?.errors);
    } else {
      await queryClient.invalidateQueries(['pedidos']);
      setShowModal(false);
    }

  } finally {
    window.hideLoader();
  }
}

  return (
    <ModalCadastro
      showModal={showModal}
      setShowModal={setShowModal}
      headerText="RESUMO DO PEDIDO"
      onClose={onClose}
    >
      <ResumoPedidoAvaliacao
        model={model}
        aprovar={aprovar}
        cancelar={cancelar}
        errors={errors}
      ></ResumoPedidoAvaliacao>

      {props.children}
    </ModalCadastro>
  );
}
